<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="BODYMATTER">
<p class="h1" id="pa1"><a href="#/text/nav#rpa1"><span class="right_1" epub:type="pagebreak" id="page_1" title="1">[Movement One]</span></a></p>
<p class="h1a"><a href="#/text/nav#rpa1">TWO STORIES</a></p>
<p class="epig1">P<span class="smallcaps">ATIENT</span> T<span class="smallcaps">RUST</span></p>
<p class="epig">Above all, trust in the slow work of God.</p>
<p class="epig">We are quite naturally impatient in everything</p>
<p class="epig-1">to reach the end without delay.</p>
<p class="epig">We should like to skip the intermediate stages. . . .</p>
<p class="epig">And yet it is the law of all progress</p>
<p class="epig-1">that it is made by passing through</p>
<p class="epig-1">some stages of instability—</p>
<p class="epig-1">and that it may take a very long time. . . .</p>
<p class="epig">Give Our Lord the benefit of believing</p>
<p class="epig-1">that his hand is leading you,</p>
<p class="epig">and accept the anxiety of feeling yourself</p>
<p class="epig-1">in suspense and incomplete.<sup><span href="#/text/9780718094966_Notes#cp1_rfn1" id="cp1_fn1" title="Link target outside of Sample">1</span></sup></p>
<p class="author">—P<span class="small">IERRE</span> T<span class="small">EILHARD DE</span> C<span class="small">HARDIN</span>, S.J.</p>
<p class="author"><i>H<span class="small">EARTS ON</span> F<span class="small">IRE</span>: P<span class="small">RAYING WITH</span> J<span class="small">ESUITS</span></i></p>
<p class="h1b">WHAT YOU WILL NEED FOR THE EXERCISES</p>
<p class="blist">•<span class="space"><span class="hide1">  </span>Life Scroll (in the Toolbox in the back of the book)</span></p>
<p class="blist">•<span class="space"><span class="hide1">  </span>A fine-point permanent marker</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780718094966_Part_1.vue?ac383370